import cx from "classnames";
import React, { useContext } from "react";
import PropTypes from "prop-types";

import global from "../../scss/dhp.scss";

import { EditorContext } from "./EditorLayout";
import Zoom from "../../components/Editor/Zoom";
import FitOnScreen from "../../components/Editor/FitOnScreen";
import PageList from "../../components/Common/PageList";
import { TYPE_INFOGRAPHIC, TYPE_PROPOSAL } from "../../constants/editor";
import { EditorWrapperContext } from "./EditorWrapper";

let style = Object.assign({}, global);

const EditorZoomNavigationPannel = props => {
  let { blockNodes, documentType, isDocumentReady, isTimeLineViewOpen, isDocumentSigned } = useContext(EditorContext);
  const { playingPageIdx } = useContext(EditorWrapperContext);

  return (
    <div
      className={cx(
        style["slide-controls"],
        style["editor-navigation"],
        style["rounded"],
        { [style["d-none"]]: !isDocumentReady },
        { [style["custom-disable"]]: playingPageIdx !== null }
      )}>
      <div className="page-info-wdg">
        <ul>
          <Zoom />
          <FitOnScreen {...props} />
          {blockNodes && blockNodes.length > 1 && !isTimeLineViewOpen && !isDocumentSigned && (
            <PageList component="Editor" />
          )}
        </ul>
      </div>
    </div>
  );
};

export default EditorZoomNavigationPannel;
